<template>
  <div :class="computedClasses">
    <h6>
      {{ $t('evocall.requests.priority')}}:
      {{ $t(`evocall.priorities.${request.priority.id}`, request.priority.name) }}
    </h6>
    <div class="d-flex flex-column align-items-center">
      <span>
        {{ $t('evocall.requests.estimated_waiting_time') }}
      </span>
      <span v-if="estimatedTimeUntilAcceptance !== null && estimatedAcceptTime > 60">
        {{ getRelativeTimeString(estimatedAcceptTime) }}
      </span>
      <span v-else>
        {{ `01${$t('time.min')}` }}
      </span>
    </div>
  </div>
</template>
<script>
import RelativeTimeMixin from '@/mixins/RelativeTimeMixin'
export default {
  mixins: [
    RelativeTimeMixin
  ],
  props: {
    request: {
      type: Object,
      required: true
    }
  },
  data: function () {
    return {
      estimatedAcceptTime: null, 
      estimatedTimeTicker: null,
    }
  },
  computed: {
    currentPriority: function () {
      return this.request.priority.name.toLowerCase()
    },
    computedClasses: function () {
      return [
        'priority',
        `priority--${this.currentPriority}`
      ]
    },
    estimatedTimeUntilAcceptance: function () {
      return this.request && this.request.estimated_accept_time ? this.moment(this.request.estimated_accept_time) : null
    },
  },
  methods: {
    decrementAcceptedTime: function () {
      if (this.estimatedTimeUntilAcceptance !== null) {
        this.estimatedAcceptTime = this.estimatedTimeUntilAcceptance.diff(this.moment(), 'seconds')
      }
    }
  },
  watch: {
    estimatedTimeUntilAcceptance: {
      handler: function (value) {
        if (value && !this.estimatedTimeTicker) {
          this.estimatedTimeTicker = setInterval(this.decrementAcceptedTime, 1000)
        }
      },
      immediate: true
    }
  },
  beforeDestroy: function () {
    if (this.estimatedTimeTicker) {
      clearInterval(this.estimatedTimeTicker)
    }
  }
  
}
</script>
<style lang="scss" scoped>
$primary-red: #c42940;
$primary-yellow: #c49d29;
$primary-green: #29c4aa;
.priority {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #fff !important;
  padding: 0.6rem 1.9rem;
  &--high {
    background-color: $primary-red;
  }
  &--normal {
    background-color: $primary-yellow;
  }
  &--low {
    background-color: $primary-green;
  }
  & h6 {
    font-weight: bold;
    color: #fff;
  }

  & div {
    font-size: 1rem;
  }
}
</style>